import React from 'react';
import PropTypes from 'prop-types';

class Node extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'Node';
    }
    render() {
        return <div>
        	<div className="node">{this.props.node}</div>
        	{(()=>{
        		if(this.props.children && this.props.children.length > 0)
        			return <ul>
		        	{React.Children.map(this.props.children, child => {
		        		return <li>{child}</li>
		        	})}
		        	</ul>
        	})()}
        </div>
    }
}

Node.propTypes = {
	node : PropTypes.node
}

export default Node;



// WEBPACK FOOTER //
// ./src/browser/components/ui/tree/node.js